import type { MigrationResult } from "@/utils/hooks/useWalletMigration";

import { useTranslation } from "@arc/i18n";
import { Drawer } from "@arc/ui/drawer";

import { MigrationResults } from "@/utils/hooks/useWalletMigration";

import { ShowMainButton } from "../MainButton";

export const WalletMigrationModal = ({
  mode,
  isOpen,
  onClose,
}: {
  mode: MigrationResult;
  isOpen: boolean;
  onClose: () => void;
}) => {
  const { t } = useTranslation("wallet");

  return (
    <ShowMainButton
      hidden={!isOpen}
      title={mode === MigrationResults.SUCCESS ? t("WALLET_MIGRATION.WOOHOO") : t("WALLET_MIGRATION.OKAY")}
      onClick={onClose}
    >
      <Drawer
        height={mode === MigrationResults.SUCCESS ? "sm" : "md"}
        isOpen={isOpen}
        title={mode === MigrationResults.SUCCESS ? t("WALLET_MIGRATION.TITLE") : t("WALLET_MIGRATION.TONCONNECT_TITLE")}
        onClose={onClose}
      >
        <div className="p-4">
          {mode === MigrationResults.SUCCESS && (
            <div className="text-headline text-center">
              <div>{t("WALLET_MIGRATION.MESSAGE")}</div>
              <br />
            </div>
          )}

          {mode === MigrationResults.TONCONNECT && (
            <div className="text-headline">
              <div>
                {t("WALLET_MIGRATION.TONCONNECT_MESSAGE")}
                <br />
                <br />
                {t("WALLET_MIGRATION.TONCONNECT_MESSAGE_2")}
                <br />
                <br />
                {t("WALLET_MIGRATION.TONCONNECT_MESSAGE_3")}
              </div>
              <br />
            </div>
          )}
        </div>
      </Drawer>
    </ShowMainButton>
  );
};
